// @flow
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import routes from '../../constants/routes';
import styles from './styles.module.scss';

const ChallengeSaveHint = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const handleEscape = (event) => {
    if (event.key === 'Escape') {
      setOpen(false);
      event.stopPropagation();
    }
  };

  return (
    <div className={styles.challengeSaveHint}>
      <div
        className={styles.challengeHelp}
        role="group"
        aria-label={t('resultsFaqLabel')}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={(event) => {
          if (!event.currentTarget.contains(document.activeElement)) setOpen(false);
        }}
        onBlur={(event) => {
          if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
        }}
      >
        <button
          type="button"
          className={styles.challengeHelpButton}
          aria-label={t('resultsFaqLabel')}
          aria-expanded={open}
          aria-controls="flop-challenge-help"
          onFocus={() => setOpen(true)}
          onClick={() => setOpen(true)}
          onKeyDown={handleEscape}
        >
          ?
        </button>
        {open && (
          <div id="flop-challenge-help" className={styles.challengeHelpContent}>
            <p>{t('challengeSaveHint')}</p>
            <p>{t('challengeSaveHelp')}</p>
            <p>{t('challengeSaveHelpStop')}</p>
            <a
              href={routes.app.resultsFAQ.root}
              target="_blank"
              rel="noopener noreferrer"
              onKeyDown={handleEscape}
            >
              {t('resultsFaqLabel')}
            </a>
          </div>
        )}
      </div>
      <p>{t('challengeSaveHint')}</p>
    </div>
  );
};

export default ChallengeSaveHint;
